import { ErrorHandler } from '@angular/core';
import { SentryHandler } from './sentry.handler';
import { environment } from '@environments/environment';

export class ErrorHandlerFactory {
  static create(): ErrorHandler {
    if (environment.sentry) {
      return new SentryHandler();
    }
    return new ErrorHandler();
  }
}
